import { useMemo, useRef } from "react";
import styles from './index.module.scss'
import { IMAGE_TYPE, DISPLAY_TYPE } from '@utils/CONST'
import DownloadBtn from '../../DownloadBtn'
import { Button, message } from 'antd';
import API from '@api/api'
import PSAIModal from '@PSAIComponents/PSAIModal'

const PicModalFooter = (props) => {
    const { item, displayType, rawTasks, setProjectId } = props

    const isLoading = useRef(false)
    const toBookmark = (e) => {
        e.stopPropagation()
        if (isLoading.current) return
        isLoading.current = true
        API.bookmarkTask({
            taskId: item?.taskId
        }).then((res) => {
            if (res?.code === 0 || typeof res?.code === 'undefined') {
                message.success(item?.bookmark ? '取消收藏' : '收藏成功')
                props.fetchProjectDetail()
            } else {
                message.error(res?.message || '操作失败')
            }
        }).finally(() => {
            isLoading.current = false
        })
    }

    const deleteClick = (e) => {
        e.stopPropagation()
        PSAIModal.confirm({
            centered: true,
            title: rawTasks?.length == 1 ? "删除该结果及项目" : "删除该结果",
            content: rawTasks?.length == 1 ? "请确认是否删除该结果及项目？" : "请确认是否删除该结果？",
            icon: null,
            onOk: hadnleDeleteTask
        })
    }
    const hadnleDeleteTask = () => {
        return API.deleteTaskImage({
            taskId: item?.taskId,
            imageId: item?.results?.[0]?.id
        }).then((res) => {
            if (res?.code === 0) {
                if (displayType == DISPLAY_TYPE.GENERATE && rawTasks?.length == 1) {
                    setProjectId('')
                }
                props.fetchProjectDetail()
                message.success('删除成功');
            } else {
                message.error('删除失败');
            }
        })
    };

    const IsEiEdit = useMemo(() => {
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_FINER ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])

    return (
        <div className={styles.PicModalFooter}>
            <Button className={styles.deleteBtn} onClick={deleteClick}>删除</Button>
            {
                !item?.orgData && <Button className={styles.collectBtn} type={item?.bookmark ? 'primary' : 'default'} 
                onClick={toBookmark}>{item?.bookmark ? '取消收藏' : '收藏'}</Button>
            }
            <DownloadBtn
                item={item}
                IsEiEdit={IsEiEdit}
                fetchProjectDetail={props.fetchProjectDetail} />
        </div>
    )
}

export default PicModalFooter
